import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { TermExplorerEffects } from './term-explorer.effects';
import { reducer } from './term-explorer.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('termExplorer', reducer),
    EffectsModule.forFeature([TermExplorerEffects]),
  ],
  providers: [TermExplorerEffects],
})
export class TermExplorerStoreModule {}
